module.exports = __webpack_public_path__ + "img/Staff Statement 24New.5b3b386d.png";